import { render, staticRenderFns } from "./mergeKlntList.vue?vue&type=template&id=3dea1659"
import script from "./mergeKlntList.vue?vue&type=script&lang=js"
export * from "./mergeKlntList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports